// src/app/services/toast.service.ts
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

export type ToastType = 'success' | 'error';

export interface ToastMessage {
  message: string;
  type: ToastType;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private toastSubject = new BehaviorSubject<ToastMessage | null>(null);
  toast$ = this.toastSubject.asObservable();

  constructor(private translate: TranslateService) { }

  show(messageKey: string, type: ToastType = 'success', duration: number = 5000) {
    
    const message = this.translate.instant(messageKey);

    this.toastSubject.next({ message, type });

    setTimeout(() => {
      this.hide();
    }, duration);
  }

  showSuccess(messageKey: string, duration?: number) {
    this.show(messageKey, 'success', duration);
  }

  showError(messageKey: string, duration?: number) {
    this.show(messageKey, 'error', duration);
  }

  hide() {
    this.toastSubject.next(null);
  }
}